import { type ConfigItem, FactSetWidget } from "./FactsetWidget";

type ChartRouletteProps = {
  identifiers: ReadonlyArray<string>;
  symbolLinkClick?: (event: any) => void;
  criteria?: any;
};

export function ChartRoulette({
  identifiers,
  symbolLinkClick,
  criteria,
}: ChartRouletteProps) {
  const config = [
    { type: "attribute", key: "identifiers", value: identifiers },
    { type: "attribute", key: "maxItems", value: 25 },
  ] as ConfigItem[];

  if (symbolLinkClick) {
    config.push({ type: "event", key: "row-click", value: symbolLinkClick });
  }

  if (criteria) {
    config.push({ type: "attribute", key: "criteria", value: criteria });
  }

  return <FactSetWidget config={config} widget="chart-roulette" />;
}
